function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { HARMONIC_2M_PATH, HARMONIC_EVENT_PATH } from '../../../utils/stream-vendor';
import { ParserAction, PatchType } from './dash-patcher-mpd.enums';
import { parse, stringify } from '@sky-uk-ott/core-video-sdk-js-external-txml';
import { matchesTag } from './manifest-utils';
import { sdkLogger } from '../../../logger';
export { ParserMode, PatchType } from './dash-patcher-mpd.enums';
var PATCH_NAMESPACES = 'mpdpatch:2020';
export var ManifestAdapter = /*#__PURE__*/ function() {
    "use strict";
    function ManifestAdapter(cdnUrl, extractOriginalLanguagesFromManifest) {
        _class_call_check(this, ManifestAdapter);
        _define_property(this, "cdnUrl", void 0);
        _define_property(this, "extractOriginalLanguagesFromManifest", void 0);
        _define_property(this, "periodContext", void 0);
        _define_property(this, "segmentContext", void 0);
        _define_property(this, "mpdId", void 0);
        _define_property(this, "publishTime", void 0);
        _define_property(this, "manifestType", void 0);
        _define_property(this, "mediaPresentationDuration", void 0);
        _define_property(this, "firstPreprocess", void 0);
        this.cdnUrl = cdnUrl;
        this.extractOriginalLanguagesFromManifest = extractOriginalLanguagesFromManifest;
        this.periodContext = new Set();
        this.segmentContext = {};
        this.mpdId = 'channel';
        this.publishTime = new Date().toISOString();
        this.manifestType = 'dynamic';
        this.firstPreprocess = true;
    }
    _create_class(ManifestAdapter, [
        {
            key: "patchMpdPreProcessor",
            value: function patchMpdPreProcessor(manifest) {
                if (!this.firstPreprocess) {
                    return;
                }
                this.firstPreprocess = false;
                var patch = {
                    tagName: 'PatchLocation',
                    attributes: {},
                    children: [
                        this.getPatchManifestUrl()
                    ]
                };
                manifest.children.push(patch);
                this.cacheFirstInitialManifest(manifest);
            }
        },
        {
            key: "cacheFirstInitialManifest",
            value: function cacheFirstInitialManifest(manifest) {
                if (manifest.attributes['publishTime']) {
                    this.publishTime = manifest.attributes['publishTime'];
                } else {
                    manifest.attributes['publishTime'] = this.publishTime;
                }
                if (manifest.attributes['id']) {
                    this.mpdId = manifest.attributes['id'];
                } else {
                    manifest.attributes['id'] = this.mpdId;
                }
                // Store this so we only update in patches if the value changes
                if (manifest.attributes['type']) {
                    this.manifestType = manifest.attributes['type'];
                } else {
                    manifest.attributes['type'] = this.manifestType;
                }
                var periods = manifest.children.filter(function(node) {
                    return matchesTag(node, 'Period');
                });
                for(var i = 0; i < periods.length; i++){
                    var period = periods[i];
                    var periodCacheKey = this.getPeriodKey(period.attributes['id']);
                    this.periodContext.add(periodCacheKey);
                    if (i === periods.length - 1) {
                        this.iterateOnSegmentTemplates(ParserAction.CACHE, period);
                    }
                }
            }
        },
        {
            key: "iterateOnSegmentTemplates",
            value: function iterateOnSegmentTemplates(action, period, additions) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = period.children.filter(function(node) {
                        return matchesTag(node, 'AdaptationSet');
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var adaptationSet = _step.value;
                        var representations = adaptationSet.children.filter(function(node) {
                            return matchesTag(node, 'Representation');
                        });
                        this.setAdaptationSetId(adaptationSet, representations);
                        // This is a peacock optimisation as we assume if there is a segment timeline
                        // this will be identical in all child representations.
                        var segmentTemplateFromAS = adaptationSet.children.filter(function(node) {
                            return matchesTag(node, 'SegmentTemplate');
                        }).pop();
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = representations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var representation = _step1.value;
                                // Cache segment template in all representations as
                                // they can appear in both AdaptationSet & Representation in subsequent manifests
                                var segmentTemplate = segmentTemplateFromAS || representation.children.filter(function(node) {
                                    return matchesTag(node, 'SegmentTemplate');
                                }).pop();
                                if (segmentTemplate) {
                                    this.handleSegmentTemplate(action, period, segmentTemplate, adaptationSet, representation, additions);
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "handleSegmentTemplate",
            value: function handleSegmentTemplate(action, period, segmentTemplate, adaptationSet, representation, additions) {
                if (action === ParserAction.PROCESS) {
                    if (additions) {
                        this.processSegmentTemplate(additions, segmentTemplate, period, adaptationSet, representation);
                    } else {
                        sdkLogger.warn('Cannot patch segment templates without additions array');
                    }
                } else {
                    this.cacheSegmentTemplate(segmentTemplate, period, adaptationSet, representation);
                }
            }
        },
        {
            key: "setAdaptationSetId",
            value: function setAdaptationSetId(adaptationSet, representations) {
                if (!adaptationSet.attributes['id']) {
                    var adaptationSetId = this.generateAdaptationSetId(adaptationSet.attributes['mimeType'], adaptationSet.attributes['lang'], representations[representations.length - 1].attributes['id']);
                    adaptationSet.attributes['id'] = adaptationSetId;
                }
            }
        },
        {
            key: "cacheSegmentTemplate",
            value: function cacheSegmentTemplate(segmentTemplate, period, adaptationSet, representation) {
                var cacheKey = this.getSegmentTimelineKey(period.attributes['id'], adaptationSet.attributes['id'], representation.attributes['id']);
                var segmentTimeline = segmentTemplate.children.filter(function(node) {
                    return matchesTag(node, 'SegmentTimeline');
                }).pop();
                if (segmentTimeline) {
                    var segmentTags = segmentTimeline.children.filter(function(node) {
                        return matchesTag(node, 'S');
                    });
                    var lastEndTime = 0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = segmentTags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var segmentTag = _step.value;
                            var _segmentTag_attributes_t;
                            var t = Number((_segmentTag_attributes_t = segmentTag.attributes['t']) !== null && _segmentTag_attributes_t !== void 0 ? _segmentTag_attributes_t : lastEndTime);
                            var d = Number(segmentTag.attributes['d']);
                            var _segmentTag_attributes_r;
                            var r = Number((_segmentTag_attributes_r = segmentTag.attributes['r']) !== null && _segmentTag_attributes_r !== void 0 ? _segmentTag_attributes_r : 0);
                            var startTime = t;
                            for(var j = 0; j <= r; ++j){
                                var endTime = startTime + d;
                                startTime = endTime;
                                lastEndTime = endTime;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.segmentContext[cacheKey] = lastEndTime;
                }
            }
        },
        {
            key: "processManifest",
            value: function processManifest(manifest) {
                var additions = [];
                var mediaPresentationDuration = manifest.attributes['mediaPresentationDuration'];
                if (mediaPresentationDuration && this.mediaPresentationDuration !== mediaPresentationDuration) {
                    additions.push({
                        xpathLocation: '/MPD/@mediaPresentationDuration',
                        type: this.mediaPresentationDuration ? PatchType.REPLACE : PatchType.ADD,
                        node: mediaPresentationDuration
                    });
                    this.mediaPresentationDuration = mediaPresentationDuration;
                }
                var manifestType = manifest.attributes['type'];
                if (manifestType && this.manifestType !== manifestType) {
                    additions.push({
                        xpathLocation: '/MPD/@type',
                        type: PatchType.REPLACE,
                        node: manifestType
                    });
                    this.manifestType = manifestType;
                }
                var periods = manifest.children.filter(function(node) {
                    return matchesTag(node, 'Period');
                });
                this.processPeriods(periods, additions);
                return additions;
            }
        },
        {
            key: "processPeriods",
            value: function processPeriods(periods, additions) {
                var _this = this;
                var newPeriodIndex = periods.findIndex(function(period) {
                    return !_this.periodContext.has(_this.getPeriodKey(period.attributes['id']));
                });
                newPeriodIndex = newPeriodIndex === -1 ? periods.length : newPeriodIndex;
                // Only process the last previously seen period
                if (newPeriodIndex > 0) {
                    this.iterateOnSegmentTemplates(ParserAction.PROCESS, periods[newPeriodIndex - 1], additions);
                }
                for(var i = newPeriodIndex; i < periods.length; i++){
                    var period = periods[i];
                    var periodCacheKey = this.getPeriodKey(period.attributes['id']);
                    if (!this.periodContext.has(periodCacheKey)) {
                        this.periodContext.add(periodCacheKey);
                        additions.push({
                            xpathLocation: '/MPD/',
                            node: period,
                            type: PatchType.ADD
                        });
                    }
                }
                // Only keep last period cached
                this.segmentContext = {};
                this.iterateOnSegmentTemplates(ParserAction.CACHE, periods[periods.length - 1]);
            }
        },
        {
            key: "processSegmentTemplate",
            value: function processSegmentTemplate(additions, segmentTemplate, period, adaptationSet, representation) {
                var _additions;
                var cacheKey = this.getSegmentTimelineKey(period.attributes['id'], adaptationSet.attributes['id'], representation.attributes['id']);
                var segmentPatches = [];
                var segmentTimeline = segmentTemplate.children.filter(function(node) {
                    return matchesTag(node, 'SegmentTimeline');
                }).pop();
                if (segmentTimeline) {
                    var segmentTags = segmentTimeline.children.filter(function(node) {
                        return matchesTag(node, 'S');
                    });
                    var _this_segmentContext_cacheKey;
                    var lastSegmentSeen = (_this_segmentContext_cacheKey = this.segmentContext[cacheKey]) !== null && _this_segmentContext_cacheKey !== void 0 ? _this_segmentContext_cacheKey : 0;
                    var lastEndTime = 0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = segmentTags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var segmentTag = _step.value;
                            var additionalSegments = 0;
                            var firstNewSegmentStartTime = void 0;
                            var _segmentTag_attributes_t;
                            var t = Number((_segmentTag_attributes_t = segmentTag.attributes['t']) !== null && _segmentTag_attributes_t !== void 0 ? _segmentTag_attributes_t : lastEndTime);
                            var d = Number(segmentTag.attributes['d']);
                            var _segmentTag_attributes_r;
                            var r = Number((_segmentTag_attributes_r = segmentTag.attributes['r']) !== null && _segmentTag_attributes_r !== void 0 ? _segmentTag_attributes_r : 0);
                            var startTime = t;
                            for(var j = 0; j <= r; ++j){
                                var endTime = startTime + d;
                                if (endTime > lastSegmentSeen) {
                                    this.segmentContext[cacheKey] = endTime;
                                    additionalSegments++;
                                    if (!firstNewSegmentStartTime) {
                                        firstNewSegmentStartTime = startTime;
                                    }
                                }
                                startTime = endTime;
                                lastEndTime = endTime;
                            }
                            if (additionalSegments > 0 && firstNewSegmentStartTime) {
                                var newSegment = {
                                    tagName: 'S',
                                    attributes: _object_spread({
                                        d: d.toString(),
                                        t: firstNewSegmentStartTime.toString()
                                    }, // minus one repeat for the original
                                    additionalSegments > 1 && {
                                        r: (additionalSegments - 1).toString()
                                    }),
                                    children: []
                                };
                                segmentPatches.push({
                                    xpathLocation: this.getSegmentXpathLocation(period, adaptationSet, representation),
                                    node: newSegment,
                                    type: PatchType.ADD
                                });
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                (_additions = additions).push.apply(_additions, _to_consumable_array(segmentPatches));
            }
        },
        {
            key: "customPatchHandler",
            value: function customPatchHandler(url, requestType) {
                var _this = this;
                return _async_to_generator(function() {
                    var manifestUrl, start, response, end, headers, status, body, _this_extractOriginalLanguagesFromManifest, _this1, manifest, additions, patchManifest, buffer, severity, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                manifestUrl = _this.getManifestUrlFromPatch(url);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                start = Date.now();
                                return [
                                    4,
                                    fetch(manifestUrl)
                                ];
                            case 2:
                                response = _state.sent();
                                end = Date.now();
                                headers = {};
                                status = response.status;
                                response.headers.forEach(function(value, key) {
                                    headers[key.trim()] = value;
                                });
                                return [
                                    4,
                                    response.text()
                                ];
                            case 3:
                                body = _state.sent();
                                if (response.ok) {
                                    ;
                                    manifest = parse(body).find(function(node) {
                                        return matchesTag(node, 'MPD');
                                    });
                                    if (!manifest) {
                                        throw new Error('No MPD Element in manifest update');
                                    }
                                    (_this_extractOriginalLanguagesFromManifest = (_this1 = _this).extractOriginalLanguagesFromManifest) === null || _this_extractOriginalLanguagesFromManifest === void 0 ? void 0 : _this_extractOriginalLanguagesFromManifest.call(_this1, manifest);
                                    additions = _this.processManifest(manifest);
                                    patchManifest = _this.generatePatch(manifest, additions);
                                    buffer = shaka.util.StringUtils.toUTF8(patchManifest);
                                    return [
                                        2,
                                        {
                                            uri: url,
                                            originalUri: url,
                                            timeMs: end - start,
                                            fromCache: false,
                                            data: buffer,
                                            headers: headers,
                                            status: status
                                        }
                                    ];
                                } else {
                                    severity = status === 401 || status === 403 ? shaka.util.Error.Severity.CRITICAL : shaka.util.Error.Severity.RECOVERABLE;
                                    throw new shaka.util.Error(severity, shaka.util.Error.Category.NETWORK, shaka.util.Error.Code.BAD_HTTP_STATUS, url, status, body, headers, requestType);
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                throw new shaka.util.Error(shaka.util.Error.Severity.RECOVERABLE, shaka.util.Error.Category.NETWORK, shaka.util.Error.Code.HTTP_ERROR, url, e, requestType);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generatePatch",
            value: function generatePatch(manifest, additions) {
                var patch = {
                    tagName: 'Patch',
                    attributes: {
                        mpdId: this.mpdId,
                        originalPublishTime: this.publishTime,
                        publishTime: new Date().toISOString()
                    },
                    children: []
                };
                this.appendXmlNamespaces(manifest, patch);
                this.generateAdditions(patch, additions);
                return stringify(patch);
            }
        },
        {
            key: "appendXmlNamespaces",
            value: function appendXmlNamespaces(originalManifest, patchManifest) {
                for(var key in originalManifest.attributes){
                    if (key.includes('xmlns')) {
                        var value = originalManifest.attributes[key];
                        if (key === 'xmlns') {
                            patchManifest.attributes['xmlns'] = "".concat(value, ":").concat(PATCH_NAMESPACES);
                        } else {
                            patchManifest.attributes[key] = originalManifest.attributes[key];
                        }
                    }
                }
            }
        },
        {
            key: "generateAdditions",
            value: function generateAdditions(patchParent, additions) {
                additions.forEach(function(patch) {
                    var patchChange = {
                        tagName: patch.type,
                        attributes: {
                            sel: patch.xpathLocation
                        },
                        children: patch.node ? [
                            patch.node
                        ] : []
                    };
                    patchParent.children.push(patchChange);
                });
            }
        },
        {
            key: "getPatchManifestUrl",
            value: function getPatchManifestUrl() {
                // This method replaces the protocol 'https' with 'patch'
                // and also changes the type of manifest that is being requested
                // to a 2 minute manifest window from a larger size of window.
                // https://github.com/NBCUDTC/core-video-sdk-js/pull/5428#discussion_r1038259178
                return this.cdnUrl.replace('https', 'patch').replace(HARMONIC_EVENT_PATH, HARMONIC_2M_PATH);
            }
        },
        {
            key: "getManifestUrlFromPatch",
            value: function getManifestUrlFromPatch(url) {
                // This is intentionally different from the method above
                // as we want to request the smaller 2 minute window manifest
                // and not the full window.
                // https://github.com/NBCUDTC/core-video-sdk-js/pull/5428#discussion_r1038259178
                return url.replace('patch', 'https');
            }
        },
        {
            key: "generateAdaptationSetId",
            value: function generateAdaptationSetId(mimeType, lang, representationId) {
                // Can be undefined from the new shaka xml parser.
                // We set all falsy values to be normalised across initial cache and patches.
                if (!lang) {
                    lang = null;
                }
                var adaptationSetId = "".concat(mimeType, "#").concat(lang);
                if (mimeType === 'audio/mp4') {
                    adaptationSetId += "#".concat(representationId);
                }
                return adaptationSetId;
            }
        },
        {
            key: "getPeriodKey",
            value: function getPeriodKey(periodId) {
                return "P_".concat(periodId);
            }
        },
        {
            key: "getSegmentTimelineKey",
            value: function getSegmentTimelineKey(periodId, adaptationSetId, representationId) {
                return "".concat(this.getPeriodKey(periodId), "_AS_").concat(adaptationSetId, "_R_").concat(representationId !== null && representationId !== void 0 ? representationId : 'xx');
            }
        },
        {
            key: "getSegmentXpathLocation",
            value: function getSegmentXpathLocation(period, adaptationSet, representation) {
                var representationCriteria = "/Representation[@id='".concat(representation.attributes['id'], "']");
                return "/MPD/Period[@id='".concat(period.attributes['id'], "']/AdaptationSet[@id='").concat(adaptationSet.attributes['id'], "']").concat(representationCriteria, "/SegmentTemplate/SegmentTimeline");
            }
        }
    ]);
    return ManifestAdapter;
}();

//# sourceMappingURL=manifest-adapter.js.map